import request from "@/utils/request"; //记得引入进来
import requestLong from "@/utils/requestLong"; //记得引入进来

export function fuzzySearch(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-all-fuzzy',
        params: data
    })
}

// 通用接口

export function allSearch(data) {
    return request({
        method: 'post',
        url: '/reader/search',
        params: data
    })
}

export function searchComplex(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-complex',
        params: data
    })
}

export function defaultSearch(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-default',
        params: data
    })
}


export function searchByAuthor(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-author',
        params: data //可以简写为data
    })
}

export function searchByTitle(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-title',
        params: data //可以简写为data
    })
}

export function searchByPublisher(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-publisher',
        params: data //可以简写为data
    })
}

export function getRecommend() {
    return request({
        method: 'get',
        url: '/reader/no-auth/notification/10-new-books-recommend',
    })
}

export function getWeekHot() {
    return request({
        method: 'get',
        url: '/reader/no-auth/notification/week-hot-rank',
    })
}

export function searchByIsbn(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-isbn',
        params: data //可以简写为data
    })
}


export function searchByDescription(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-description',
        params: data //可以简写为data
    })
}

export function searchByYear(data) {
    return request({
        method: 'post',
        url: '/reader/search/search-by-year',
        params: data //可以简写为data
    })
}

export function getBook(md5) {
    return request({
        method: 'get',
        url: '/reader/search/get-book/' + md5,
    })
}

export function getIfShelf(data) {
    return request({
        method: 'put',
        url: '/reader/check-in-shelf',
        params: data
    })
}

export function addShelf(data) {
    return request({
        method: 'post',
        url: '/reader/add-shelf',
        params: data
    })
}


export function delShelf(data) {
    return request({
        method: 'post',
        url: '/reader/delete-shelf',
        params: data
    })
}

export function downloadBook(data) {
    return requestLong({
        method: 'post',
        url: '/reader/download',
        params: data,
        responseType: 'blob'
    })
}

export function readPdf(data) {
    return requestLong({
        method: 'get',
        url: '/reader/read',
        params: data,
        responseType: 'blob'
    })
}



export function getBookSum() {
    return request({
        method: 'get',
        url: '/reader/no-auth/notification/organization-book-num',
    })
}


export function readBook(params) {
    return request({
        method: 'get',
        url: '/reader/read',
        params: params
    })
}